import React from 'react';
import styles from './field-wrapper.scss';
import classNames from 'classnames';
const FieldWrapper = _ref => {
  let {
    children,
    dataHook,
    fieldType,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": "form-field-" + dataHook,
    "data-field-type": fieldType,
    className: classNames([styles.container, className])
  }, children);
};
export default FieldWrapper;
//# sourceMappingURL=field-wrapper.js.map